import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, Search, ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#080808] text-white flex flex-col">
      <Helmet>
        <title>Seite nicht gefunden | HUWND</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header />

      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="text-center max-w-md">
          {/* 404 Number */}
          <div className="relative mb-8 select-none">
            <span
              className="text-[160px] font-black leading-none text-transparent"
              style={{
                WebkitTextStroke: "1px rgba(255,255,255,0.05)",
              }}
            >
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-5xl font-black text-white/10">404</span>
            </div>
          </div>

          <h1 className="text-2xl font-black text-white mb-3">{t("not_found.title")}</h1>
          <p className="text-zinc-500 text-sm leading-relaxed mb-8">
            {t("not_found.desc")}
          </p>

          <div className="flex items-center justify-center gap-3 flex-wrap">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-zinc-900/60 border border-white/[0.06] text-zinc-400 hover:text-white hover:border-white/10 text-sm font-medium transition-all"
              data-testid="404-back-btn"
            >
              <ChevronLeft size={14} />
              {t("not_found.back_btn")}
            </button>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-rose-600 hover:bg-rose-500 text-white text-sm font-medium transition-all shadow-[0_4px_12px_rgba(225,29,72,0.25)]"
              data-testid="404-home-btn"
            >
              <Home size={14} />
              {t("not_found.home_btn")}
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-zinc-900/60 border border-white/[0.06] text-zinc-400 hover:text-white hover:border-white/10 text-sm font-medium transition-all"
              data-testid="404-search-btn"
            >
              <Search size={14} />
              {t("not_found.search_btn")}
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
